export enum EProductPublishMode {
  CREATE_PRODUCT = 'create_product',
  BULK_EDIT = 'bulk_edit',
  BULK_CONNECT = 'bulk_connect',
  VARIANT_CONNECT = 'variant_connect',
  EXPAND_CATEGORIES = 'expand_categories',
  PRODUCT_EXPANSION = 'product_expansion',
}
